import { Level } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { Platform, SafeAreaView, StyleSheet, View } from 'react-native';
import { SkillLevelSelection } from '../Bookings/components/SkillLevelSelection';
import { Button } from '../components';
import Theme, { ThemeType } from '../theme';
import { FormError } from '../ui';
import { isWeb, Logger, UserDataConsumer } from '../utils';
import { OnBoardingHeader, OnBoardingProgress } from './components';
import { styles as SharedStyles } from './SignupFormsStyles';

interface IProps {
  t: (key: string) => string;
  user: any;
  navigation: any;
}

interface IState {
  isLoading: boolean;
  error: any;
  skillLevel: Level | null;
}

class SkillLevel extends PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      skillLevel: null,
      isLoading: false,
      error: null,
    };
  }

  public setSkillLevel = async (skillLevel) => {
    await this.setState({ skillLevel });
  }

  public saveSkillLevel = async () => {
    try {
      const { skillLevel } = this.state;
      const { user: { userProfile, userProfileService }, navigation } = this.props;

      await this.setState({ isLoading: true, error: null });

      userProfile.skillLevel = skillLevel;
      await userProfileService.updateUserProfile(
        userProfile,
        true, // updatedAtOnboardingComplete,
      );
      const screenToNavigateTo = isWeb() ? 'HomeInstallAppScreen' : 'HomeLoading';
      navigation.navigate(screenToNavigateTo);
    } catch (error) {
      this.setState({ error: new Error('Oops, something went wrong.') });
      Logger.notify(error);
    } finally {
      await this.setState({ isLoading: false });
    }
  }

  public render() {
    const { t } = this.props;
    const { skillLevel, isLoading, error } = this.state;

    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: Theme.WHITE }}>
        <OnBoardingProgress step={5.5} />
        <View style={[SharedStyles.container, styles.container]}>
          <View style={styles.body}>
            <OnBoardingHeader
              header={t('setYourSkillLevel')}
              subheader={t('toAdjustWorkoutDifficulty')}
              theme={ThemeType.light}
            />
            <View style={styles.skillLevelContainer}>
              <SkillLevelSelection
                theme={ThemeType.light}
                skillLevel={skillLevel}
                onPress={this.setSkillLevel}
              />
            </View>
          </View>

          <View>
            <FormError error={error} />
            <Button
              title={t('next')}
              isLoading={isLoading}
              disabled={!skillLevel}
              fontColor={Theme.WHITE}
              containerStyle={{ marginBottom: 20, marginTop: 10 }}
              onPress={this.saveSkillLevel}
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '90%',
    backgroundColor: Theme.WHITE,
  },
  body: {
    flex: 1,
    justifyContent: 'center',
  },
  skillLevelContainer: {
    ...Platform.select({
      web: {
        flex: 1,
        justifyContent: 'center',
      },
    }),
  },
});

const UserSkillLevel = UserDataConsumer(SkillLevel);
export const SkillLevelScreen = translate(['auth', 'formFields'], { wait: true })(UserSkillLevel);
